import axios from "axios";
import { getShopImportPO, setShopImportPO } from "./importPOActions";
import { setNotify } from "./uiActions";
import { serverUrl } from "../../serverUrl";
import { setBusy } from "./uiActions";
import { okRes, errRes } from "../../utils/httpSerialize";
import { countRows, summarizeDatabaseState, superSyncLog } from "../../utils/superSyncLog";

export const getRetail = (token_user_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retail`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_user_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setRetail(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getRetailRSYNC = (token_company_id, token_user_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retailR/SYNC`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setRetail(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};
export const getRestoKRSYNC = (token_company_id, token_user_id, syncId) => {
  return (dispatch, getState) => {
    superSyncLog(syncId, "RESTOK_SYNC_REQUEST_START", summarizeDatabaseState(getState()));

    const config = {
      method: "post",
      url: `${serverUrl}/api/list/restoK/SYNC`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id },
    };

    axios(config)
      .then((resp) => {
        superSyncLog(syncId, "RESTOK_SYNC_RESPONSE", {
          responseCount: countRows(resp.data),
          beforeDispatch: summarizeDatabaseState(getState()),
        });

        const syncListCount = countRows(resp.data);
        if (syncListCount > 0) {
          dispatch(setRestoK(resp.data, syncId));
        } else {
          superSyncLog(syncId, "RESTOK_SYNC_EMPTY_LIST_KEEP_EXISTING", {
            responseCount: syncListCount,
            state: summarizeDatabaseState(getState()),
          });
        }

        const state = getState();
        superSyncLog(syncId, "RESTOK_SYNC_AFTER_SET_RESTOK", summarizeDatabaseState(state));

        const isActiveCompany =
          state.database.currentCompany.type === "RESTOK" &&
          String(state.database.currentCompany.id) === String(token_company_id);

        if (!isActiveCompany) {
          superSyncLog(syncId, "RESTOK_SYNC_SKIP_INACTIVE_COMPANY", {
            token_company_id,
            state: summarizeDatabaseState(state),
          });
          return;
        }

        const areaId = state.database.currentShop.area_id ?? 0;
        superSyncLog(syncId, "RESTOK_SYNC_REFETCH_ACTIVE_TAB", {
          table: state.ui.table,
          areaId,
          state: summarizeDatabaseState(state),
        });

        switch (state.ui.table) {
          case 1:
            dispatch(getAreaCategoriesK(token_user_id, token_company_id, areaId, syncId));
            break;
          case 4:
            dispatch(getAreaCategoriesOtherK(token_user_id, token_company_id, areaId, syncId));
            break;
          case 7:
            dispatch(getAreaTaxesK(token_user_id, token_company_id, areaId, syncId));
            break;
          default:
            dispatch(getAreaPaymentsK(token_user_id, token_company_id, areaId, syncId));
        }
      })
      .catch((err) => {
        superSyncLog(syncId, "RESTOK_SYNC_REQUEST_ERROR", { message: err?.message, response: err?.response?.data });
        console.log(err);
      });
  };
};

export const getRetailXRSYNC = (token_company_id, token_user_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retailx/SYNC`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setRetailX(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getRestoLRSYNC = (token_company_id, token_user_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/restoL/SYNC`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setResto(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getResto = (token_user_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/resto`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_user_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setResto(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getRestoK = (token_user_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/restoK`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_user_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setRestoK(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getRetailX = (token_user_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retailX`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_user_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setRetailX(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getCurrentRetail = (token_company_id, token_user_id) => {
  return (dispatch, getState) => {
    //console.log("RETAIL2 --->>> ",getState().ui.table)
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retail/shops`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id },
    };

    axios(config)
      .then((resp) => {
        const companyMeta = getState().database.retail.find(
          (item) => String(item.company_id) === String(token_company_id)
        );
        dispatch(setCurrentRetail(resp.data, token_company_id, companyMeta));
        switch (getState().ui.table) {
          case 1:
            dispatch(setShopCategories([]));
            dispatch(
              getShopCategories(
                token_company_id,
                getState().userState.user.user_id,
                resp.data[0].shop_id
              )
            );
            break;
          case 2:
            dispatch(
              getShopCategoriesMulti(
                token_company_id,
                getState().userState.user.user_id,
                resp.data[0].shop_id
              )
            );
            break;
          case 3:
            dispatch(
              getShopCategoriesRound(
                token_company_id,
                getState().userState.user.user_id,
                resp.data[0].shop_id
              )
            );
            break;
          case 4:
            dispatch(getShopCategoriesOther(token_company_id, token_user_id, resp.data[0].shop_id));
            break;
          case 5:
            dispatch(
              getShopCategoriesLess(
                token_company_id,
                getState().userState.user.user_id,
                resp.data[0].shop_id
              )
            );
            break;
          case 6:
           /* dispatch(
              getReports(token_company_id, getState().userState.user.user_id, resp.data[0].shop_id)
            );*/
            break;

          /*  
          case 7:
              
              dispatch(setShopCategories([]));
              dispatch(
                getShopCategories(
                  token_company_id,
                  getState().userState.user.user_id,
                  resp.data[0].shop_id
                )
              );
              break;
          */

          case 7:
            dispatch(setShopTaxes([]));
            dispatch(
              getShopTaxes(
                token_company_id,
                getState().userState.user.user_id,
                resp.data[0].shop_id
              )
            );
            break;

          case 8:
            dispatch(setShopImport([]));
            dispatch(
              getShopImport(
                token_company_id,
                getState().userState.user.user_id,
                resp.data[0].shop_id
              )
            );
            break;

          case 13:
            dispatch(setShopImportPO([]));
            dispatch(getShopImportPO(
              token_company_id,
              getState().userState.user.user_id,
              resp.data[0].shop_id
            ));
            break;

          default:
            dispatch(
              getShopPayments(
                token_company_id,
                getState().userState.user.user_id,
                resp.data[0].shop_id
              )
            );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getCurrentRetailX = (token_company_id, token_user_id) => {
  return (dispatch, getState) => {
    console.log("R X  --->>> ",getState().ui.table)
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retailX/shops`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id },
    };

    // PROMJENA
    axios(config)
      .then((resp) => {
        dispatch(setCurrentRetailX(resp.data, token_company_id));
        switch (getState().ui.table) {
          case 1:
            dispatch(setShopCategoriesX([]));
            dispatch(
              getShopCategoriesX(
                token_company_id,
                getState().userState.user.user_id,
                resp.data[0].shop_id
              )
            );
            break;
          case 2:
            dispatch(
              getShopCategoriesMultiX(
                token_company_id,
                getState().userState.user.user_id,
                resp.data[0].shop_id
              )
            );
            break;
          case 3:
            dispatch(
              getShopCategoriesRoundX(
                token_company_id,
                getState().userState.user.user_id,
                resp.data[0].shop_id
              )
            );
            break;
          case 4:
            dispatch(getShopCategoriesOtherX(token_company_id, token_user_id, resp.data[0].shop_id));
            break;
          case 5:
            dispatch(
              getShopCategoriesLessX(
                token_company_id,
                getState().userState.user.user_id,
                resp.data[0].shop_id
              )
            );
            break;
          case 6:
            dispatch(
              //getReportsX(token_company_id, getState().userState.user.user_id, resp.data[0].shop_id)
            );
            break;


          case 7:
            dispatch(setShopTaxesX([]));
            dispatch(
              getShopTaxesX(
                token_company_id,
                getState().userState.user.user_id,
                resp.data[0].shop_id
              )
            );
            break;
          default:
            dispatch(
              getShopPaymentsX(
                token_company_id,
                getState().userState.user.user_id,
                resp.data[0].shop_id
              )
            );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getShopPayments = (token_company_id, token_user_id, token_shop_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retail/payments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id, token_shop_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setShopPayments(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getShopPaymentsX = (token_company_id, token_user_id, token_shop_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retailX/payments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id, token_shop_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setShopPaymentsX(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getShopTaxes = (token_company_id, token_user_id, token_shop_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retail/taxes`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id, token_shop_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setShopTaxes(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getShopImport = (
  token_company_id,
  token_user_id,
  token_shop_id,
  journal_entry_id = null
) => {
  return async (dispatch, getState) => {
    try {
      const requestData = {
        token_company_id,
        token_user_id,
        token_shop_id,
        xoption: "QuickBooksIMPORT GET_LIST",
      };

      if (journal_entry_id != null && journal_entry_id !== "") {
        requestData.journal_entry_id = journal_entry_id;
      }

      const config = {
        method: "post",
        url: `${serverUrl}/api/admin/retailr/report`,
        headers: { "Content-Type": "application/json" },
        data: requestData,
      };

      const resp = await axios(config);

      dispatch(setBusy(true));

      if (journal_entry_id != null && journal_entry_id !== "" && !Array.isArray(resp.data)) {
        const currentImports = getState().database.currentShop?.imports;
        const currentList = Array.isArray(currentImports)
          ? currentImports
          : Object.values(currentImports || {});
        const responseItem = Array.isArray(resp.data?.data)
          ? resp.data.data[0]
          : resp.data;
        const nextList = currentList.map((item) => {
          const itemId = item?.journalentry_id ?? item?.journal_entry_id;
          const responseId =
            responseItem?.journalentry_id ??
            responseItem?.journal_entry_id ??
            journal_entry_id;
          return String(itemId) === String(responseId)
            ? { ...item, ...responseItem }
            : item;
        });
        dispatch(setShopImport(nextList));
      } else {
        dispatch(setShopImport(resp.data));
      }

      return resp.data;
    } catch (err) {
      console.log(err);
      return [];
    }
  };
};


export const getShopTaxesX = (token_company_id, token_user_id, token_shop_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retailX/taxes`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id, token_shop_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setShopTaxesX(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getShopCategories = (token_company_id, token_user_id, token_shop_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retail/categories`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id, token_shop_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setShopCategories(resp.data, token_shop_id));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getShopCategoriesX = (token_company_id, token_user_id, token_shop_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retailX/categories`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id, token_shop_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setShopCategoriesX(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};


export const getShopCategoriesMulti = (token_company_id, token_user_id, token_shop_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retail/categoriesmulti`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id, token_shop_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setShopCategoriesMulti(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};



export const getShopCategoriesMultiX = (token_company_id, token_user_id, token_shop_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retailX/categoriesmulti`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id, token_shop_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setShopCategoriesMultiX(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};


export const getShopCategoriesMultiFree = (token_company_id, token_user_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/retail/categoriesmultifree`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id, token_category_id:"0" },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setShopCategoriesMultiFree(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};
export const addShopCategoriesMulti = (
  token_company_id,
  token_user_id,
  token_shop_id,
  token_category_id,
  callback
) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/retail/categoriesmulticreate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_company_id,
        token_user_id,
        token_shop_id,
        token_category_id,
      },
    };

    axios(config)
      .then(() => {
        dispatch(setBusy(true));
        dispatch(callback(token_company_id, token_user_id, token_shop_id));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};
export const updateShopCategoriesMulti = (
  token_company_id,
  token_user_id,
  token_shop_id,
  token_category_id,
  token_multi_id,
  token_account_id,
  token_account_name,
  token_amount,
  callback
) => {
  return (dispatch) => {
    const config = {
      method: "put",
      url: `${serverUrl}/api/retail/categoriesmultiupdate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_company_id,
        token_user_id,
        token_shop_id,
        token_category_id,
        token_multi_id,
        token_account_id,
        token_account_name,
        token_amount,
      },
    };

    axios(config)
      .then(() => {
        dispatch(setBusy(true));
        dispatch(callback(token_company_id, token_user_id, token_shop_id));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};
export const removeShopCategoriesMulti = (
  token_company_id,
  token_user_id,
  token_shop_id,
  token_category_id,
  callback
) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/retail/categoriesmultidelete`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_company_id,
        token_user_id,
        token_shop_id,
        token_category_id,
      },
    };

    axios(config)
      .then(() => {
        dispatch(setBusy(true));
        dispatch(callback(token_company_id, token_user_id, token_shop_id));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getShopCategoriesRound = (token_company_id, token_user_id, token_shop_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retail/categoriesround`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id, token_shop_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setShopCategoriesRound(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};


export const getShopCategoriesRoundX = (token_company_id, token_user_id, token_shop_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retailX/categoriesround`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id, token_shop_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setShopCategoriesRoundX(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getShopCategoriesOther = (token_company_id, token_user_id, token_shop_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retail/other`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id, token_shop_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setShopCategoriesOther(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getShopCategoriesOtherX = (token_company_id, token_user_id, token_shop_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retailX/other`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id, token_shop_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setShopCategoriesOtherX(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getShopCategoriesLess = (token_company_id, token_user_id, token_shop_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retail/items`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id, token_shop_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setShopCategoriesLess(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getShopCategoriesLessX = (token_company_id, token_user_id, token_shop_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retailX/items`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_company_id, token_user_id, token_shop_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setShopCategoriesLessX(resp.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getCurrentResto = (token_user_id, token_company_id, area_visible) => {
  return (dispatch, getState) => {
    const url = `${serverUrl}/api/list/resto/areas`;
    const data = { token_user_id, token_company_id };
    const config = {
      method: "post",
      url,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    };

    if (area_visible === 1) {
      axios(config)
        .then((resp) => {
          dispatch(setCurrentResto(resp.data, token_company_id));
          switch (getState().ui.table) {
            case 1:
              dispatch(
                getAreaCategories(
                  getState().userState.user.user_id,
                  token_company_id,
                  resp.data[0].area_id
                )
              );
              break;
            case 4:
              dispatch(
                getAreaCategoriesOther(
                  getState().userState.user.user_id,
                  token_company_id,
                  resp.data[0].area_id
                )
              );
              break;

            case 7:
              dispatch(
                getAreaTaxes(
                  getState().userState.user.user_id,
                  token_company_id,
                  resp.data[0].area_id
                )
              );
              break;
            default:
              dispatch(
                getAreaPayments(
                  getState().userState.user.user_id,
                  token_company_id,
                  resp.data[0].area_id
                )
              );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      switch (getState().ui.table) {
        case 1:
          dispatch(getAreaCategories(getState().userState.user.user_id, token_company_id, 0));
          break;
        case 4:
          dispatch(getAreaCategoriesOther(getState().userState.user.user_id, token_company_id, 0));
          break;
        case 7:
          dispatch(getAreaTaxes(getState().userState.user.user_id, token_company_id, 0));

          break;
        default:
          dispatch(getAreaPayments(getState().userState.user.user_id, token_company_id, 0));
      }
    }
  };
};

export const getCurrentRestoK = (token_user_id, token_company_id, area_visible) => {
  return (dispatch, getState) => {
    const url = `${serverUrl}/api/list/resto/areasK`;
    const data = { token_user_id, token_company_id };
    const config = {
      method: "post",
      url,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    };

    if (area_visible === 1) {
      axios(config)
        .then((resp) => {
          /*
          PROMJENA
          setCurrentResto
          setCurrentRestoK
          */
          const companyMeta = getState().database.restoK.find(
            (item) => String(item.company_id) === String(token_company_id)
          );
          dispatch(setCurrentRestoK(resp.data, token_company_id, companyMeta));

          const selectedAreaId = getState().database.currentShop.area_id || resp.data?.[0]?.area_id;
          if (!selectedAreaId) return;

          console.log("PRINT 22", getState().ui.table);

          switch (getState().ui.table) {
            case 1:
              dispatch(
                getAreaCategoriesK(
                  getState().userState.user.user_id,
                  token_company_id,
                  selectedAreaId
                )
              );
              break;
            case 4:
              dispatch(
                getAreaCategoriesOtherK(
                  getState().userState.user.user_id,
                  token_company_id,
                  selectedAreaId
                )
              );
              break;

            case 7:
              dispatch(
                getAreaTaxesK(
                  getState().userState.user.user_id,
                  token_company_id,
                  selectedAreaId
                )
              );

              break;
            default:
              dispatch(
                getAreaPaymentsK(
                  getState().userState.user.user_id,
                  token_company_id,
                  selectedAreaId
                )
              );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      switch (getState().ui.table) {
        case 1:
          dispatch(getAreaCategories(getState().userState.user.user_id, token_company_id, 0));
          break;
        case 4:
          dispatch(getAreaCategoriesOther(getState().userState.user.user_id, token_company_id, 0));
          break;
        case 7:
          dispatch(getAreaTaxes(getState().userState.user.user_id, token_company_id, 0));

          break;
        default:
          dispatch(getAreaPayments(getState().userState.user.user_id, token_company_id, 0));
      }
    }
  };
};

export const getCurrentRetailShop = (token_company_id, token_shop_id) => {
  return (dispatch, getState) => {
    console.log("RETAIL1 --->>> ", getState().ui.table);
    const userId = getState().userState.user.user_id;

    switch (getState().ui.table) {
      case 1:
        dispatch(setShopCategories([]));
        dispatch(getShopCategories(token_company_id, userId, token_shop_id));
        break;

      case 2:
        dispatch(getShopCategoriesMulti(token_company_id, userId, token_shop_id));
        break;

      case 3:
        dispatch(getShopCategoriesRound(token_company_id, userId, token_shop_id));
        break;

      case 4:
        // 🔧 dodat userId koji je nedostajao
        dispatch(getShopCategoriesOther(token_company_id, userId, token_shop_id));
        break;

      case 6:
        dispatch(getShopCategoriesLess(token_company_id, userId, token_shop_id));
        break;

      case 7:
        dispatch(getShopTaxes(token_company_id, userId, token_shop_id));
        break;

      case 8:
        dispatch(setShopImport([])); // opcionalno: clear prije fetcha
        dispatch(getShopImport(token_company_id, userId, token_shop_id));
        break;

      case 13:
        dispatch(setShopImportPO([]));
        dispatch(getShopImportPO(token_company_id, userId, token_shop_id));
        break;

      default:
        dispatch(getShopPayments(token_company_id, userId, token_shop_id));
    }
  };
};



export const getCurrentRetailShopX = (token_company_id, token_shop_id) => {
  return (dispatch, getState) => {
    console.log("RETAILXXXX 222 --->>> ", getState().ui.table);
    const userId = getState().userState.user.user_id;

    switch (getState().ui.table) {
      case 1:
        dispatch(setShopCategoriesX([]));
        dispatch(getShopCategoriesX(token_company_id, userId, token_shop_id));
        break;

      case 2:
        dispatch(getShopCategoriesMultiX(token_company_id, userId, token_shop_id));
        break;

      case 3:
        dispatch(getShopCategoriesRoundX(token_company_id, userId, token_shop_id));
        break;

      case 4:
        // 🔧 dodat userId koji je nedostajao
        dispatch(getShopCategoriesOtherX(token_company_id, userId, token_shop_id));
        break;

      case 6:
        dispatch(getShopCategoriesLessX(token_company_id, userId, token_shop_id));
        break;

      case 7:
        dispatch(getShopTaxesX(token_company_id, userId, token_shop_id));
        break;

      case 8:
        // Ako koristiš Imports i za RetailX, uključi ovo.
        // Ako nemaš X endpoint, ili koristi isti getShopImport, ili ukloni ovaj case.
        dispatch(setShopImport([]));
        dispatch(getShopImport(token_company_id, userId, token_shop_id));
        break;

      default:
        dispatch(getShopPaymentsX(token_company_id, userId, token_shop_id));
    }
  };
};



export const getCurrentRestoArea = (token_company_id, token_area_id) => {
  return (dispatch, getState) => {
    switch (getState().ui.table) {
      case 1:
        dispatch(
          getAreaCategories(getState().userState.user.user_id, token_company_id, token_area_id)
        );
        break;
      case 4:
        dispatch(
          getAreaCategoriesOther(getState().userState.user.user_id, token_company_id, token_area_id)
        );
        break;
      case 7:
        dispatch(getAreaTaxes(getState().userState.user.user_id, token_company_id, token_area_id));
        break;
      case 9:
        dispatch(setShopImport([]));
        dispatch(getShopImport(token_company_id, getState().userState.user.user_id, token_area_id));
        break;
      default:
        dispatch(
          getAreaPayments(getState().userState.user.user_id, token_company_id, token_area_id)
        );
    }
  };
};

export const getCurrentRestoAreaK = (token_company_id, token_area_id) => {
  return (dispatch, getState) => {
    switch (getState().ui.table) {
      case 1:
        dispatch(
          getAreaCategoriesK(getState().userState.user.user_id, token_company_id, token_area_id)
        );
        break;
      case 4:
        dispatch(
          getAreaCategoriesOtherK(getState().userState.user.user_id, token_company_id, token_area_id)
        );
        break;
      case 7:
        dispatch(getAreaTaxesK(getState().userState.user.user_id, token_company_id, token_area_id));
        break;
      case 9:
        dispatch(setShopImport([]));
        dispatch(getShopImport(token_company_id, getState().userState.user.user_id, token_area_id));
        break;
      default:
        dispatch(
          getAreaPaymentsK(getState().userState.user.user_id, token_company_id, token_area_id)
        );
    }
  };
};

export const getAreaPayments = (token_user_id, token_company_id, token_area_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/resto/payments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_user_id, token_company_id, token_area_id },
    };
    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setAreaPayments(resp.data, token_area_id));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getAreaPaymentsK = (token_user_id, token_company_id, token_area_id, syncId) => {
  return (dispatch) => {
    dispatch(setTableLoading("payments", true));
    superSyncLog(syncId, "RESTOK_PAYMENTS_FETCH_START", { token_company_id, token_area_id });
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/resto/paymentsK`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_user_id, token_company_id, token_area_id },
    };
    axios(config)
      .then((resp) => {
        superSyncLog(syncId, "RESTOK_PAYMENTS_FETCH_RESPONSE", { token_company_id, token_area_id, responseCount: countRows(resp.data) });
        dispatch(setBusy(true));
        dispatch(setAreaPayments(resp.data, token_area_id, syncId));
      })
      .catch((err) => {
        dispatch(setTableLoading("payments", false));
        superSyncLog(syncId, "RESTOK_PAYMENTS_FETCH_ERROR", { token_company_id, token_area_id, message: err?.message, response: err?.response?.data });
        console.log(err);
      });
  };
};

export const getAreaTaxes = (token_user_id, token_company_id, token_area_id) => {
  //console.log(333)
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/resto/taxex`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_user_id, token_company_id, token_area_id },
    };
    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setAreaTaxes(resp.data, token_area_id));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getAreaTaxesK = (token_user_id, token_company_id, token_area_id, syncId) => {
  //console.log(333)
  return (dispatch) => {
    dispatch(setTableLoading("taxes", true));
    superSyncLog(syncId, "RESTOK_TAXES_FETCH_START", { token_company_id, token_area_id });
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/resto/taxexK`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_user_id, token_company_id, token_area_id },
    };
    axios(config)
      .then((resp) => {
        superSyncLog(syncId, "RESTOK_TAXES_FETCH_RESPONSE", { token_company_id, token_area_id, responseCount: countRows(resp.data) });
        dispatch(setBusy(true));
        dispatch(setAreaTaxesK(resp.data, token_area_id, syncId));
      })
      .catch((err) => {
        dispatch(setTableLoading("taxes", false));
        superSyncLog(syncId, "RESTOK_TAXES_FETCH_ERROR", { token_company_id, token_area_id, message: err?.message, response: err?.response?.data });
        console.log(err);
      });
  };
};

export const getAreaCategories = (token_user_id, token_company_id, token_area_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/resto/categories`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_user_id, token_company_id, token_area_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setAreaCategories(resp.data, token_area_id));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getAreaCategoriesK = (token_user_id, token_company_id, token_area_id, syncId) => {
  return (dispatch) => {
    dispatch(setTableLoading("categories", true));
    superSyncLog(syncId, "RESTOK_CATEGORIES_FETCH_START", { token_company_id, token_area_id });
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/restoK/categories`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_user_id, token_company_id, token_area_id },
    };

    axios(config)
      .then((resp) => {
        superSyncLog(syncId, "RESTOK_CATEGORIES_FETCH_RESPONSE", { token_company_id, token_area_id, responseCount: countRows(resp.data) });
        dispatch(setBusy(true));
        dispatch(setAreaCategories(resp.data, token_area_id, syncId));
      })
      .catch((err) => {
        dispatch(setTableLoading("categories", false));
        superSyncLog(syncId, "RESTOK_CATEGORIES_FETCH_ERROR", { token_company_id, token_area_id, message: err?.message, response: err?.response?.data });
        console.log(err);
      });
  };
};

export const getAreaCategoriesOther = (token_user_id, token_company_id, token_area_id) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/resto/other`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_user_id, token_company_id, token_area_id },
    };

    axios(config)
      .then((resp) => {
        dispatch(setBusy(true));
        dispatch(setAreaCategoriesOther(resp.data, token_area_id));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getAreaCategoriesOtherK = (token_user_id, token_company_id, token_area_id, syncId) => {
  return (dispatch) => {
    dispatch(setTableLoading("other", true));
    superSyncLog(syncId, "RESTOK_OTHER_FETCH_START", { token_company_id, token_area_id });
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/resto/otherK`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { token_user_id, token_company_id, token_area_id },
    };

    axios(config)
      .then((resp) => {
        superSyncLog(syncId, "RESTOK_OTHER_FETCH_RESPONSE", { token_company_id, token_area_id, responseCount: countRows(resp.data) });
        dispatch(setBusy(true));
        dispatch(setAreaCategoriesOtherK(resp.data, token_area_id, syncId));
      })
      .catch((err) => {
        dispatch(setTableLoading("other", false));
        superSyncLog(syncId, "RESTOK_OTHER_FETCH_ERROR", { token_company_id, token_area_id, message: err?.message, response: err?.response?.data });
        console.log(err);
      });
  };
};

export const updateRetailTaxes = (
  token_user_id,
  token_company_id,
  token_shop_id,
  token_account_id,
  token_account_name,
  token_payment_id,
  token_class_department_location,
  token_customer_id,
  token_customer_id2,
  token_d365_dimensions = undefined,
  token_tax_class_allocation = undefined,
  dispatch_on_done
) => {
  return (dispatch) => {
    if (typeof token_d365_dimensions === "function") {
      dispatch_on_done = token_d365_dimensions;
      token_d365_dimensions = undefined;
    }
    if (typeof token_tax_class_allocation === "function") {
      dispatch_on_done = token_tax_class_allocation;
      token_tax_class_allocation = undefined;
    }
    const config = {
      method: "put",
      url: `${serverUrl}/api/retail/taxesupdate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_user_id,
        token_company_id,
        token_shop_id,
        token_account_id,
        token_account_name,
        token_payment_id,
        token_class_department_location,
        qb_customer_id: token_customer_id,
        token_d365_dimensions: token_d365_dimensions ?? "",
        tax_class_allocation: token_tax_class_allocation ?? "",
      },
    };

    axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};

export const updateRetailTaxesX = (
  token_user_id,
  token_company_id,
  token_shop_id,
  token_account_id,
  token_account_name,
  token_payment_id,
  token_class_department_location,
  token_customer_id,
  token_customer_id2,
  dispatch_on_done
) => {
  return (dispatch) => {
    const config = {
      method: "put",
      url: `${serverUrl}/api/retailx/taxesupdate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_user_id,
        token_company_id,
        token_shop_id,
        token_account_id,
        token_account_name,
        token_payment_id,
        token_class_department_location,
        qb_customer_id: token_customer_id2,
      },
    };

   axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};

export const updateRetailPayment = (
  token_user_id,
  token_company_id,
  token_shop_id,
  token_account_id,
  token_account_name,
  token_payment_id,
  token_over_short_id,
  token_over_short_name,
  token_class_department_location,
  token_customer_id = null,
  token_customer_id2 = null,
  token_account_id_deferred = null,
  token_account_name_deferred = null,
  token_d365_dimensions = undefined,
  dispatch_on_done
) => {
  return (dispatch) => {
    if (typeof token_d365_dimensions === "function") {
      dispatch_on_done = token_d365_dimensions;
      token_d365_dimensions = undefined;
    }
    if (typeof token_customer_id === "function") {
      dispatch_on_done = token_customer_id;
      token_customer_id = null;
      token_customer_id2 = null;
    }

    const config = {
      method: "put",
      url: `${serverUrl}/api/retail/paymentsupdate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_user_id,
        token_company_id,
        token_shop_id,
        token_account_id,
        token_account_name,
        token_payment_id,
        token_over_short_id,
        token_over_short_name,
        token_class_department_location,
        qb_customer_id: token_customer_id ?? token_customer_id2 ?? null,
        token_account_id_deferred,
        token_account_name_deferred,
        token_d365_dimensions: token_d365_dimensions ?? "",
      },
    };

      axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};


export const updateRetailPaymentDeferred = (
  token_user_id,
  token_company_id,
  token_shop_id,
  token_account_id,
  token_account_name,
  token_payment_id,
  token_over_short_id,
  token_over_short_name,
  token_class_department_location,
  token_customer_id = null,
  token_customer_id2 = null,
  token_account_id_deferred = null,
  token_account_name_deferred = null,
  dispatch_on_done
) => {
  return (dispatch) => {
    if (typeof token_customer_id === "function") {
      dispatch_on_done = token_customer_id;
      token_customer_id = null;
      token_customer_id2 = null;
    }

    const config = {
      method: "put",
      url: `${serverUrl}/api/retail/paymentsupdateDeferred`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_user_id,
        token_company_id,
        token_shop_id,
        token_account_id,
        token_account_name,
        token_payment_id,
        token_over_short_id,
        token_over_short_name,
        token_class_department_location,
        qb_customer_id: token_customer_id ?? token_customer_id2 ?? null,
        token_account_id_deferred,
        token_account_name_deferred
      },
    };

      axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};

export const updateRetailPaymentX = (
  token_user_id,
  token_company_id,
  token_shop_id,
  token_account_id,
  token_account_name,
  token_payment_id,
  token_over_short_id,
  token_over_short_name,
  token_class_department_location,
  token_customer_id = null,
  token_customer_id2 = null,
  token_account_id_deferred = null,
  token_account_name_deferred = null,
  dispatch_on_done
) => {
  return (dispatch) => {
    if (typeof token_customer_id === "function") {
      dispatch_on_done = token_customer_id;
      token_customer_id = null;
      token_customer_id2 = null;
    }

    const config = {
      method: "put",
      url: `${serverUrl}/api/retail/paymentsupdateX`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_user_id,
        token_company_id,
        token_shop_id,
        token_account_id,
        token_account_name,
        token_payment_id,
        token_over_short_id,
        token_over_short_name,
        token_class_department_location,
        qb_customer_id: token_customer_id ?? token_customer_id2 ?? null,
        token_account_id_deferred,
        token_account_name_deferred
      },
    };

   axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};

export const updateRetailCategory = (
  token_user_id,
  token_company_id,
  token_shop_id,
  token_account_id,
  token_account_name,
  token_category_id,
  token_flash,
  token_cogs,
  token_cogs_description,
  token_cogs2,
  token_cogs_description2,
  token_class_department_location,
  token_customer_id,
  token_customer_id2,
  token_account_id_deferred = null,
  token_account_name_deferred = null,
  token_d365_dimensions = undefined,
  dispatch_on_done,
  discountMapping = {}
) => {
  return (dispatch) => {
    if (typeof token_d365_dimensions === "function") {
      dispatch_on_done = token_d365_dimensions;
      token_d365_dimensions = undefined;
    }
    if (typeof token_account_id_deferred === "function") {
      dispatch_on_done = token_account_id_deferred;
      token_account_id_deferred = null;
      token_account_name_deferred = null;
    }

    const config = {
      method: "put",
      url: `${serverUrl}/api/retail/categoriesupdate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        ...discountMapping,
        token_company_id,
        token_user_id,
        token_category_id,
        token_account_id,
        token_account_name,
        token_account_id_deferred,
        token_account_name_deferred,
        token_shop_id,
        token_flash,
        token_cogs,
        token_cogs_description,
        token_cogs2,
        token_cogs_description2,
        token_class_department_location,
        qb_customer_id: token_customer_id ?? token_customer_id2 ?? null,
        token_d365_dimensions: token_d365_dimensions ?? "",
      },
    };

   axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};

export const updateRetailCategoryDeferred = (
  token_user_id,
  token_company_id,
  token_shop_id,
  token_account_id,
  token_account_name,
  token_category_id,
  token_flash,
  token_cogs,
  token_cogs_description,
  token_cogs2,
  token_cogs_description2,
  token_class_department_location,
  token_customer_id,
  token_customer_id2,
  token_account_id_deferred = null,
  token_account_name_deferred = null,
  dispatch_on_done) => {
  return (dispatch) => {
    if (typeof token_account_id_deferred === "function") {
      dispatch_on_done = token_account_id_deferred;
      token_account_id_deferred = null;
      token_account_name_deferred = null;
    }

    const config = {
      method: "put",
      url: `${serverUrl}/api/retail/categoriesupdateDeferred`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_company_id,
        token_user_id,
        token_category_id,
        token_account_id,
        token_account_name,
        token_account_id_deferred,
        token_account_name_deferred,
        token_shop_id,
        token_flash,
        token_cogs,
        token_cogs_description,
        token_cogs2,
        token_cogs_description2,
        token_class_department_location,
        qb_customer_id: token_customer_id ?? token_customer_id2 ?? null,
      },
    };

   axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};

export const updateRetailCategoryX = (
  token_user_id,
  token_company_id,
  token_shop_id,
  token_account_id,
  token_account_name,
  token_category_id,
  token_flash,
  token_cogs,
  token_cogs2,
  token_cogs_description,
  token_cogs_description2,
  token_class_department_location,
  token_customer_id,
  token_customer_id2,
  token_account_id_deferred = null,
  token_account_name_deferred = null,
  dispatch_on_done,
  discountMapping = {}
) => {
  return (dispatch) => {
    if (typeof token_account_id_deferred === "function") {
      dispatch_on_done = token_account_id_deferred;
      token_account_id_deferred = null;
      token_account_name_deferred = null;
    }

    const config = {
      method: "put",
      url: `${serverUrl}/api/retail/categoriesupdateX`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        ...discountMapping,
        token_company_id,
        token_user_id,
        token_category_id,
        token_account_id,
        token_account_name,
        token_account_id_deferred,
        token_account_name_deferred,
        token_shop_id,
        token_flash,
        token_cogs,
        token_cogs2,
        token_cogs_description,
        token_cogs_description2,
        token_class_department_location,
        qb_customer_id: token_customer_id ?? token_customer_id2 ?? null,
      },
    };
   axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};

export const updateRetailCategoryRound = (
  token_user_id,
  token_company_id,
  token_shop_id,
  token_account_id,
  token_account_name,
  token_category_id,
  dispatch_on_done
) => {
  return (dispatch) => {
    const config = {
      method: "put",
      url: `${serverUrl}/api/retail/categoriesroundupdate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_user_id,
        token_company_id,
        token_shop_id,
        token_account_id,
        token_account_name,
        token_category_id,
      },
    };

   axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};
export const updateRetailOther = (
  token_company_id,
  token_user_id,
  token_shop_id,
  token_what,
  token_code,
  token_code_name,
  token_code2,
  token_code_name2,
  class1,
  class2,
  token_d365_dimensions = undefined,
  dispatch_on_done
) => {
  return (dispatch) => {
    if (typeof token_d365_dimensions === "function") {
      dispatch_on_done = token_d365_dimensions;
      token_d365_dimensions = undefined;
    }
    const config = {
      method: "put",
      url: `${serverUrl}/api/retail/otherupdate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_company_id,
        token_user_id,
        token_shop_id,
        token_what,
        token_code,
        token_code_name,
        token_code2,
        token_code_name2,
        class1,
        class2,
        token_d365_dimensions: token_d365_dimensions ?? "",
      },
    };

   axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};

export const updateRetailOtherX = (
  token_company_id,
  token_user_id,
  token_shop_id,
  token_what,
  token_code,
  token_code_name,
  class1,
  class2,
  dispatch_on_done
) => {
  return (dispatch) => {
    const config = {
      method: "put",
      url: `${serverUrl}/api/retail/otherupdateX`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_company_id,
        token_user_id,
        token_shop_id,
        token_what,
        token_code,
        token_code_name,
        class1,
        class2,
      },
    };

   axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};

export const updateRestoPayments = (
  token_user_id,
  token_company_id,
  token_payment_id,
  token_account_id,
  token_account_name,
  token_area_id,
  token_class_department_location,
  token_customer_id = null,
  token_customer_id2 = null,
  dispatch_on_done
) => {
  return (dispatch) => {
    if (typeof token_customer_id === "function") {
      dispatch_on_done = token_customer_id;
      token_customer_id = null;
      token_customer_id2 = null;
    }

    const config = {
      method: "put",
      url: `${serverUrl}/api/resto/paymentsupdate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_user_id,
        token_company_id,
        token_payment_id,
        token_account_id,
        token_account_name,
        token_area_id,
        token_class_department_location,
        qb_customer_id: token_customer_id ?? token_customer_id2 ?? null,
      },
    };

   axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};

export const updateRestoPaymentsK = (
  token_user_id,
  token_company_id,
  token_payment_id,
  token_account_id,
  token_account_name,
  token_area_id,
  token_class_department_location,
  token_customer_id = null,
  token_customer_id2 = null,
  token_meal_period_mappings = null,
  token_d365_dimensions = undefined,
  dispatch_on_done
) => {
  return (dispatch) => {
    if (typeof token_d365_dimensions === "function") {
      dispatch_on_done = token_d365_dimensions;
      token_d365_dimensions = undefined;
    }
    if (typeof token_customer_id2 === "function") {
      dispatch_on_done = token_customer_id2;
      token_meal_period_mappings = token_customer_id;
      token_customer_id = null;
      token_customer_id2 = null;
    }

    const normalizedMealPeriodMappings =
      token_meal_period_mappings == null || typeof token_meal_period_mappings === "string"
        ? token_meal_period_mappings
        : JSON.stringify(token_meal_period_mappings);

    const config = {
      method: "put",
      url: `${serverUrl}/api/resto/paymentsupdateK`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_user_id,
        token_company_id,
        token_payment_id,
        token_account_id,
        token_account_name,
        token_area_id,
        token_class_department_location,
        qb_customer_id: token_customer_id ?? token_customer_id2 ?? null,
        token_meal_period_mappings: normalizedMealPeriodMappings,
        token_d365_dimensions: token_d365_dimensions ?? "",
      },
    };

   axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};

export const updateRestoTaxes = (
  token_user_id,
  token_company_id,
  token_payment_id,
  token_account_id,
  token_account_name,
  token_area_id,
  token_class_department_location,
  token_customer_id,
  token_customer_id2,
  dispatch_on_done
) => {
  return (dispatch) => {
    const config = {
      method: "put",
      url: `${serverUrl}/api/resto/taxessupdate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_user_id,
        token_company_id,
        token_payment_id,
        token_account_id,
        token_account_name,
        token_area_id,
        token_class_department_location,
        qb_customer_id: token_customer_id,
      },
    };

   axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};

export const updateRestoTaxesK = (
  token_user_id,
  token_company_id,
  token_payment_id,
  token_account_id,
  token_account_name,
  token_area_id,
  token_class_department_location,
  token_customer_id,
  token_customer_id2,
  token_meal_period_mappings,
  token_d365_dimensions,
  dispatch_on_done
) => {
  return (dispatch) => {
    if (typeof token_d365_dimensions === "function") {
      dispatch_on_done = token_d365_dimensions;
      token_d365_dimensions = undefined;
    }
    const normalizedMealPeriodMappings =
      token_meal_period_mappings == null ||
      token_meal_period_mappings === 0 ||
      typeof token_meal_period_mappings === "string"
        ? token_meal_period_mappings === 0
          ? null
          : token_meal_period_mappings
        : JSON.stringify(token_meal_period_mappings);

    const config = {
      method: "put",
      url: `${serverUrl}/api/resto/taxessupdateK`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_user_id,
        token_company_id,
        token_payment_id,
        token_account_id,
        token_account_name,
        token_area_id,
        token_class_department_location,
        qb_customer_id: token_customer_id,
        token_meal_period_mappings: normalizedMealPeriodMappings,
        token_d365_dimensions: token_d365_dimensions ?? "",
      },
    };

   axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};


export const updateRestoCategories = (
  token_user_id,
  token_company_id,
  token_category_id,
  token_account_id,
  token_account_name,
  token_area_id,
  token_class_department_location,
  token_customer_id,
  token_customer_id2,
  dispatch_on_done
) => {
  return (dispatch, getState) => {
    const payload = {
      token_user_id,
      token_company_id,
      token_category_id,
      token_account_id,
      token_account_name,
      token_area_id,
      token_class_department_location,
      qb_customer_id: token_customer_id2 ?? token_customer_id ?? null,
    };

    const config = {
      method: "put",
      url: `${serverUrl}/api/resto/categoriesupdate`,
      headers: { "Content-Type": "application/json" },
      data: payload,
    };

    axios(config)
      .then((res) => {
        // ✅ pošalji samo serijalizabilne dijelove
        dispatch(setNotify(false, okRes(res)));

        // ✅ ne dispatchaj undefined
        if (dispatch_on_done) {
          dispatch(
            typeof dispatch_on_done === "function"
              ? dispatch_on_done()   // thunk creator ili action factory
              : dispatch_on_done     // plain action
          );
        }
      })
      .catch((err) => {
        // ✅ pošalji samo serijalizabilne dijelove
        dispatch(setNotify(true, errRes(err)));

        if (dispatch_on_done) {
          dispatch(
            typeof dispatch_on_done === "function"
              ? dispatch_on_done()
              : dispatch_on_done
          );
        }
      });
  };
};


export const updateRestoCategoriesK = (
  token_user_id,
  token_company_id,
  token_category_id,
  token_account_id,
  token_account_name,
  token_area_id,
  token_cogs,
  token_cogs_name,
  token_cogs2,
  token_cogs_name2,
  token_class_department_location,
  token_customer_id,
  token_customer_id2,
  token_meal_period_mappings,
  token_d365_dimensions,
  dispatch_on_done,
  discountMapping = {}
) => {
  return (dispatch, getState) => {
    if (typeof token_d365_dimensions === "function") {
      dispatch_on_done = token_d365_dimensions;
      token_d365_dimensions = undefined;
    }
    const normalizedMealPeriodMappings =
      token_meal_period_mappings == null ||
      token_meal_period_mappings === 0 ||
      typeof token_meal_period_mappings === "string"
        ? token_meal_period_mappings === 0
          ? null
          : token_meal_period_mappings
        : JSON.stringify(token_meal_period_mappings);

    const config = {
      method: "put",
      url: `${serverUrl}/api/resto/categoriesupdateK`,
      headers: { "Content-Type": "application/json" },
      data: {
        ...discountMapping,
        token_user_id,
        token_company_id,
        token_category_id,
        token_account_id,
        token_account_name,
        token_area_id,
        token_cogs,
        token_cogs_name,
        token_cogs2,
        token_cogs_name2,
        token_class_department_location,
        qb_customer_id: token_customer_id2 ?? token_customer_id ?? null,
        token_meal_period_mappings: normalizedMealPeriodMappings,
        token_d365_dimensions: token_d365_dimensions ?? "",
      },
    };

    axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};


export const updateRestoOther = (
  token_company_id,
  token_area_id,
  token_what,
  token_code,
  token_code_name,
  token_code2,
  token_code_name2,
  class1,
  class2,
  dispatch_on_done
) => {
  return (dispatch) => {
    const config = {
      method: "put",
      url: `${serverUrl}/api/resto/otherupdate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_company_id,
        token_area_id,
        token_what,
        token_code,
        token_code_name,
        token_code2,
        token_code_name2,
        class1,
        class2,
      },
    };

   axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};

export const updateRestoOtherK = (
  token_company_id,
  token_area_id,
  token_what,
  token_code,
  token_code_name,
  token_code2,
  token_code_name2,
  class1,
  class2,
  token_meal_period_mappings,
  token_d365_dimensions,
  dispatch_on_done
) => {
  return (dispatch) => {
    if (typeof token_d365_dimensions === "function") {
      dispatch_on_done = token_d365_dimensions;
      token_d365_dimensions = undefined;
    }
    const normalizedMealPeriodMappings =
      token_meal_period_mappings == null ||
      token_meal_period_mappings === 0 ||
      typeof token_meal_period_mappings === "string"
        ? token_meal_period_mappings === 0
          ? null
          : token_meal_period_mappings
        : JSON.stringify(token_meal_period_mappings);

    const config = {
      method: "put",
      url: `${serverUrl}/api/resto/otherupdateK`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token_company_id,
        token_area_id,
        token_what,
        token_code,
        token_code_name,
        token_code2,
        token_code_name2,
        class1,
        class2,
        token_meal_period_mappings: normalizedMealPeriodMappings,
        token_d365_dimensions: token_d365_dimensions ?? "",
      },
    };

   axios(config)
      .then((res) => {
        dispatch(setNotify(false, okRes(res)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      })
      .catch((err) => {
        dispatch(setNotify(true, errRes(err)));
        if (dispatch_on_done) dispatch(dispatch_on_done);
      });
  };
};

const setRetail = (retail) => ({ type: "SET_RETAIL", payload: retail });
const setResto = (restoL) => ({ type: "SET_RESTO", payload: restoL });
const setRestoK = (restoK, syncId) => ({ type: "SET_RESTOK", payload: restoK, meta: { syncId } });
const setRetailX = (retailX) => ({ type: "SET_RETAILX", payload: retailX });


const setCurrentRetail = (currentRetail, id, companyMeta = {}) => ({
  type: "SET_CURRENT_RETAIL",
  payload: { currentRetail, id, companyMeta },
});
const setCurrentRetailX = (currentRetail, id) => ({
  type: "SET_CURRENT_RETAILX",
  payload: { currentRetail, id },
});

export const setShopPayments = (payments) => ({
  type: "SET_CURRENT_SHOP_PAYMENTS",
  payload: payments,
});

// ===================== DEFERRED (Payments/Categories) =====================
export const setShopPaymentsDeferred = (payments) => ({
  type: "SET_SHOP_PAYMENTS_DEFERRED",
  payload: payments,
});

export const getShopPaymentsDeferred = (companyId, userId, shopId) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retail/paymentsDeferred`,
      headers: { "Content-Type": "application/json" },
      data: { token_company_id: companyId, token_user_id: userId, token_shop_id: shopId },
    };

    axios(config)
      .then((res) => {
        dispatch(setShopPaymentsDeferred(res.data));
      })
      .catch((err) => {
        console.log("getShopPaymentsDeferred err:", err);
        dispatch(setShopPaymentsDeferred([]));
      });
  };
};

export const setShopCategoriesDeferred = (categories) => ({
  type: "SET_SHOP_CATEGORIES_DEFERRED",
  payload: categories,
});

export const getShopCategoriesDeferred = (companyId, userId, shopId) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/list/retail/categoriesDeferred`,
      headers: { "Content-Type": "application/json" },
      data: { token_company_id: companyId, token_user_id: userId, token_shop_id: shopId },
    };

    axios(config)
      .then((res) => {
        dispatch(setShopCategoriesDeferred(res.data));
      })
      .catch((err) => {
        console.log("getShopCategoriesDeferred err:", err);
        dispatch(setShopCategoriesDeferred([]));
      });
  };
};
// ========================================================================

export const setShopPaymentsX = (payments) => ({
  type: "SET_CURRENT_SHOPX_PAYMENTS",
  payload: payments,
});

//PROMJENA TAX R
export const setShopTaxes = (taxes) => ({
  type: "SET_CURRENT_SHOP_TAXES",
  payload: taxes,
});

export const setShopImport = (imports) => ({
  type: "SET_CURRENT_SHOP_IMPORT",
  payload: imports,
});


//PROMJENA TAX X
export const setShopTaxesX = (taxes) => ({
  type: "SET_CURRENT_SHOPX_TAXES",
  payload: taxes,
});

export const setShopCategories = (categories, shopId) => ({
  type: "SET_CURRENT_SHOP_CATEGORIES",
  payload: categories,
  meta: { shop_id: shopId },
});

export const setShopCategoriesX = (categories) => ({
  type: "SET_CURRENT_SHOPX_CATEGORIES",
  payload: categories,
});

export const setShopCategoriesMulti = (multi) => ({
  type: "SET_CURRENT_SHOP_CATEGORIES_MULTI",
  payload: multi,
});

export const setShopCategoriesMultiX = (multi) => ({
  type: "SET_CURRENT_SHOPX_CATEGORIES_MULTI",
  payload: multi,
});

export const setShopCategoriesMultiFree = (free) => ({
  type: "SET_CURRENT_SHOP_CATEGORIES_MULTI_FREE",
  payload: free,
});

export const setShopCategoriesMultiFreeX = (free) => ({
  type: "SET_CURRENT_SHOPX_CATEGORIES_MULTI_FREE",
  payload: free,
});


export const setShopCategoriesMultiAdd = (newItem) => ({
  type: "SET_CURRENT_SHOP_CATEGORIES_MULTI_ADD",
  payload: newItem,
});
export const setShopCategoriesRound = (categories) => ({
  type: "SET_CURRENT_SHOP_CATEGORIES_ROUND",
  payload: categories,
});

export const setShopCategoriesRoundX = (categories) => ({
  type: "SET_CURRENT_SHOPX_CATEGORIES_ROUND",
  payload: categories,
});

export const setShopCategoriesOther = (other) => ({
  type: "SET_CURRENT_SHOP_CATEGORIES_OTHER",
  payload: other,
});

export const setShopCategoriesOtherX = (other) => ({
  type: "SET_CURRENT_SHOPX_CATEGORIES_OTHER",
  payload: other,
});

export const setShopCategoriesLess = (less) => ({
  type: "SET_CURRENT_SHOP_CATEGORIES_LESS",
  payload: less,
});

export const setShopCategoriesLessX = (less) => ({
  type: "SET_CURRENT_SHOPX_CATEGORIES_LESS",
  payload: less,
});

export const setShopReport = (reports) => ({
  type: "SET_CURRENT_SHOP_REPORT",
  payload: reports,
});
export const setCurrentResto = (currentResto, id) => ({
  type: "SET_CURRENT_RESTO",
  payload: { currentResto, id },
});
export const setCurrentRestoK = (currentRestoK, id, companyMeta = {}) => ({
  type: "SET_CURRENT_RESTOK",
  payload: { currentRestoK, id, companyMeta },
});

export const setFiltered = (filtered) => ({
  type: "SET_CURRENT_FILTERED_RETAL_RESTO_SHOPS",
  payload: filtered,
});
export const setCurrentRestoDirect = (trueFalse) => ({
  type: "SET_CURRENT_RESTO_DIRECT",
  payload: trueFalse,
});
export const setCurrentCompanyId = (id) => ({
  type: "SET_CURRENT_COMPANY_ID",
  payload: id,
});
export const setCurrentShopId = (id) => ({
  type: "SET_CURRENT_SHOP_ID",
  payload: id,
});

export const setCurrentShopIdX = (id) => ({
  type: "SET_CURRENT_SHOP_IDX",
  payload: id,
});

export const setCurrentCompanyType = (value) => ({
  type: "SET_CURRENT_COMPANY_TYPE",
  payload: value,
});
export const setCurrentCompanyIntegrationName = (value) => ({
  type: "SET_CURRENT_COMPANY_INTEGRATION_NAME",
  payload: value,
});
export const setCurrentShopCompanyId = (id) => ({
  type: "SET_CURRENT_SHOP_COMPANY_ID",
  payload: id,
});

export const setCurrentShopCompanyIdX = (id) => ({
  type: "SET_CURRENT_SHOPX_COMPANY_ID",
  payload: id,
});

export const setCurrentAreaId = (id) => ({
  type: "SET_CURRENT_AREA_ID",
  payload: id,
});
export const setCurrentAreaIdK = (id) => ({
  type: "SET_CURRENT_AREA_ID",
  payload: id,
});
export const setAreaPayments = (payments, areaId, syncId) => ({
  type: "SET_CURRENT_AREA_PAYMENTS",
  payload: payments,
  meta: { area_id: areaId, syncId },
});
export const patchCurrentAreaPayment = (paymenttype_id, updates) => ({
  type: "PATCH_CURRENT_AREA_PAYMENT",
  payload: { paymenttype_id, updates },
});
export const setAreaTaxes = (taxes, areaId, syncId) => ({
  type: "SET_CURRENT_AREA_TAXES",
  payload: taxes,
  meta: { area_id: areaId, syncId },
});
export const setAreaTaxesK = (taxes, areaId, syncId) => ({
  type: "SET_CURRENT_AREA_TAXES",
  payload: taxes,
  meta: { area_id: areaId, syncId },
});
export const setAreaCategories = (categories, areaId, syncId) => ({
  type: "SET_CURRENT_AREA_CATEGORIES",
  payload: categories,
  meta: { area_id: areaId, syncId },
});
export const patchCurrentAreaCategory = (category_id, updates) => ({
  type: "PATCH_CURRENT_AREA_CATEGORY",
  payload: { category_id, updates },
});
export const setAreaCategoriesK = (categories, areaId, syncId) => ({
  type: "SET_CURRENT_AREA_CATEGORIESK",
  payload: categories,
  meta: { area_id: areaId, syncId },
});
export const setAreaCategoriesOther = (other, areaId, syncId) => ({
  type: "SET_CURRENT_AREA_CATEGORIES_OTHER",
  payload: other,
  meta: { area_id: areaId, syncId },
});
export const setAreaCategoriesOtherK = (other, areaId, syncId) => ({
  type: "SET_CURRENT_AREA_CATEGORIES_OTHER",
  payload: other,
  meta: { area_id: areaId, syncId },
});

export const setTableLoading = (key, value) => ({
  type: "SET_TABLE_LOADING",
  payload: { key, value },
});

